import React from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from '@components-library/Typography';
import { IRowSelectionActions, RowSelectionAction } from '@components-shared/table/types';
import { KeyMapKeys } from '@locales/lokalise/keyMap';

interface ITableRowSelectionButtonProps {
  rowSelectionActions?: IRowSelectionActions;
  onRowSelectionButtonClick: (action: RowSelectionAction) => void;
  selectedRowsIds: number[];
}

export const TableRowSelectionButton = ({
  rowSelectionActions,
  selectedRowsIds,
  onRowSelectionButtonClick,
}: ITableRowSelectionButtonProps) => {
  const { i18n } = useTranslation();

  if (!rowSelectionActions) {
    return <></>;
  }

  const { actions } = rowSelectionActions as IRowSelectionActions;

  if (actions.length == 0 || selectedRowsIds.length == 0) {
    return <></>;
  }

  return (
    <div className={rowSelectionActions.className}>
      {actions.map((rowAction) => (
        <button
          type="button"
          title={rowAction ? i18n.t(rowAction.tooltip as KeyMapKeys) : ''}
          className={rowAction.className}
          key={rowAction.name}
          onClick={() => onRowSelectionButtonClick(rowAction)}>
          <Text>{rowAction.name}</Text>
        </button>
      ))}
    </div>
  );
};
